import { render, staticRenderFns } from "./KitchenCategoryForm.vue?vue&type=template&id=fde19bb6&"
import script from "./KitchenCategoryForm.vue?vue&type=script&lang=js&"
export * from "./KitchenCategoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports